const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI;

export const oauthProviders = {
  google: {
    authorize: () => {
      if (!GOOGLE_CLIENT_ID) {
        throw new Error('Google OAuth credentials not configured');
      }

      // Detect if we're in an embedded webview
      const isEmbedded = /wv|WebView/.test(navigator.userAgent);

      // Add state parameter with user agent info
      const state = btoa(JSON.stringify({
        returnTo: '/calendar',
        returnTo: '/',
        userAgent: navigator.userAgent,
        isEmbedded,
        clientId: GOOGLE_CLIENT_ID,
        redirectUri: GOOGLE_REDIRECT_URI
      }));

      // Store state for verification
      sessionStorage.setItem('oauth_state', state);

      // Build OAuth URL
      const params = new URLSearchParams({
        client_id: GOOGLE_CLIENT_ID,
        redirect_uri: GOOGLE_REDIRECT_URI,
        response_type: 'code',
        scope: 'https://www.googleapis.com/auth/calendar.readonly',
        access_type: 'offline',
        prompt: 'consent',
        state
      });

      const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;

      if (isEmbedded) {
        // Open in system browser for embedded webviews
        window.location.href = `intent://${authUrl}#Intent;scheme=https;package=com.android.chrome;end`;
      } else {
        // Regular web flow
        window.location.href = authUrl;
      }
    }
  }
};